// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"80167fa38b303f3e","8152":"6ce547b4645081a6"}[chunkId] + ".css";
};